export const tr = {
  "app.title": "survivrr.io",
  "menu.online": "Çevrimiçi",
  "menu.offline": "Çevrimdışı",
  "menu.play": "Oyna",
  "menu.name": "Ad",
  "menu.ballColor": "Top rengi",
  "menu.nameColor": "Ad rengi",
  "menu.moreInfo": "Daha fazla bilgi",
  "menu.moreInfoTitle": "Daha fazla bilgi",
  "menu.moreInfoSubtitle": "Yasal sayfalar, çerez ayrıntıları ve iletişim bilgileri.",
  "menu.back": "Geri",
  "menu.privacySettings": "Gizlilik ayarlarÄ±",
  "menu.cookiePolicy": "Çerez politikası",
  "menu.privacyPolicy": "Gizlilik politikasÄ±",
  "menu.termsOfService": "Hizmet şartları",
  "menu.emailButton": "E-posta gönder",
  "menu.websiteButton": "Web sitemi gör",
  "menu.contactEmailLabel": "İletişim e-postası:",
  "menu.emailLabel": "E-posta:",
  "menu.websiteLabel": "Web sitemi gör:",
  "menu.nameRequired": "Önce bir ad girin.",
  "moreInfo.privacySettings.intro1": "Bu sitedeki gizlilik tercihlerinizi, mevcut olduğunda reklam sağlayıcımız tarafından gösterilen izin mesajı üzerinden yönetebilirsiniz.",
  "moreInfo.privacySettings.intro2": "Çerezleri ve yerel depolamayı istediğiniz zaman tarayıcı ayarlarınızdan da kontrol edebilirsiniz.",
  "moreInfo.privacySettings.adsHeading": "Reklam kontrolleri",
  "moreInfo.privacySettings.adsParagraph": "Bazı reklamlar Google veya diğer ortaklar tarafından sağlanabilir. Kişiselleştirilmiş reklam tercihleri doğrudan Google reklam ayarlarından da yönetilebilir.",
  "moreInfo.privacySettings.adsBullet1": "Google reklam kontrollerini myadcenter.google.com adresinde açın.",
  "moreInfo.privacySettings.adsBullet2": "İzin tercihlerinizi sıfırlamak istiyorsanız çerezleri veya site verilerini temizleyin.",
  "moreInfo.privacySettings.adsBullet3": "Çerezleri engellemek veya sınırlamak için tarayıcı gizlilik ayarlarınızı kullanın.",
  "moreInfo.privacySettings.localHeading": "Yerel ayarlar",
  "moreInfo.privacySettings.localParagraph": "Bu oyun, sitenin cihazınızda hatırlayabilmesi için oyuncu adınız, renkleriniz, ses tercihiniz ve diliniz gibi temel yerel tercihleri kaydeder.",
  "moreInfo.cookiePolicy.intro1": "Bu site oyunu çalıştırmak, ayarlarınızı hatırlamak ve reklamları desteklemek için çerezler ve benzer depolama teknolojileri kullanır.",
  "moreInfo.cookiePolicy.intro2": "Çerezler, izin tercihlerinize ve sitede etkinleştirilen hizmetlere bağlı olarak ölçüm, dolandırıcılığı önleme ve reklam kişiselleştirme için de kullanılabilir.",
  "moreInfo.cookiePolicy.typesHeading": "Kullanabileceğimiz çerez ve depolama türleri",
  "moreInfo.cookiePolicy.typeBullet1": "Sitenin çalışması için kullanılan gerekli depolama.",
  "moreInfo.cookiePolicy.typeBullet2": "Adınızı, renklerinizi, dilinizi ve ses ayarınızı hatırlamak için kullanılan tercih depolaması.",
  "moreInfo.cookiePolicy.typeBullet3": "Reklamlar etkin olduğunda Google gibi reklam ortakları tarafından kullanılan reklam veya ölçüm çerezleri.",
  "moreInfo.cookiePolicy.manageHeading": "Çerezler nasıl yönetilir",
  "moreInfo.cookiePolicy.manageParagraph": "Çerezleri, mevcut olduğunda sitedeki izin mesajı üzerinden veya tarayıcı ayarlarınızdan yönetebilirsiniz. Bazı çerezleri devre dışı bırakmak site özelliklerini veya reklam gösterimini etkileyebilir.",
  "moreInfo.privacyPolicy.intro1": "Bu site, Michał Kierzkowski tarafından işletilen bir tarayıcı oyunudur. Mümkün olduğunca az kişisel bilgi toplamayı amaçlarız.",
  "moreInfo.privacyPolicy.intro2": "Oynamak için hesap gerekmez. Oyun cihazınızda temel yerel tercihleri kaydedebilir ve çevrimiçi maçları çalıştırmak için gereken oyun verilerini işleyebilir.",
  "moreInfo.privacyPolicy.infoHeading": "İşleyebileceğimiz bilgiler",
  "moreInfo.privacyPolicy.infoBullet1": "Seçtiğiniz oyuncu adı ve kozmetik ayarlar.",
  "moreInfo.privacyPolicy.infoBullet2": "Çok oyunculu özellikleri çalıştırmak için gerekli temel oturum verileri.",
  "moreInfo.privacyPolicy.infoBullet3": "Bu hizmetler etkinse analiz veya reklam ortaklarÄ± tarafÄ±ndan toplanan cihaz, tarayÄ±cÄ± veya reklam verileri.",
  "moreInfo.privacyPolicy.useHeading": "Bilgileri nasÄ±l kullanÄ±rÄ±z",
  "moreInfo.privacyPolicy.useBullet1": "Oyunu ve çevrimiçi odaları çalıştırmak için.",
  "moreInfo.privacyPolicy.useBullet2": "Ayarlarınızı cihazınızda hatırlamak için.",
  "moreInfo.privacyPolicy.useBullet3": "Performans, güvenlik ve kararlılığı iyileştirmek için.",
  "moreInfo.privacyPolicy.useBullet4": "Reklamlar etkin olduğunda reklam göstermek için.",
  "moreInfo.privacyPolicy.contactHeading": "İletişim",
  "moreInfo.privacyPolicy.contactParagraph1": "Gizlilikle ilgili sorularınız için iletişim: mjkierzkowski@gmail.com",
  "moreInfo.privacyPolicy.contactParagraph2": "Web sitesi: michalkierzkowski.com",
  "moreInfo.terms.intro1": "Bu siteyi kullanarak oyunu yasal ve adil şekilde kullanmayı kabul edersiniz.",
  "moreInfo.terms.intro2": "Oyun olduğu gibi sunulur ve herhangi bir zamanda değiştirilebilir, kesintiye uğrayabilir veya kaldırılabilir.",
  "moreInfo.terms.rulesHeading": "Kurallar",
  "moreInfo.terms.ruleBullet1": "Hataları, hileleri, otomasyonu veya açıkları kötüye kullanmayın.",
  "moreInfo.terms.ruleBullet2": "Hizmete veya diğer oyunculara zarar vermeye çalışmayın.",
  "moreInfo.terms.ruleBullet3": "Saldırgan, yasa dışı veya yanıltıcı adlar ya da içerikler kullanmayın.",
  "moreInfo.terms.limitationHeading": "SÄ±nÄ±rlama",
  "moreInfo.terms.limitationParagraph": "Yasaların izin verdiği azami ölçüde, sitenin kullanımından doğan kayıplar, kesintiler veya zararlardan sorumlu değiliz.",
  "moreInfo.terms.changesHeading": "Değişiklikler",
  "moreInfo.terms.changesParagraph": "Bu şartlar gelecekte güncellenebilir. Güncellemelerden sonra siteyi kullanmaya devam etmek, güncellenmiş şartları kabul ettiğiniz anlamına gelir.",
  "status.offline": "Çevrimdışı maç başlatılıyor...",
  "status.connecting": "Sunucuya bağlanılıyor...",
  "queue.title": "Oda bekleniyor",
  "queue.menu": "Ana menüye dön",
  "game.pressToMove": "Hareket etmek için herhangi bir yere basın",
  "game.touchToMove": "Hareket etmek için herhangi bir yere dokunun",
  "game.leaderboard": "Lider tablosu",
  "game.hp": "Can",
  "game.level": "Seviye",
  "game.xp": "XP",
  "game.respawning": "Yeniden doğuluyor...",
  "gameEnd.title": "Oyun bitti",
  "gameEnd.winTitle": "KazandÄ±n",
  "gameEnd.subtitle": "Maç sona erdi. Sonraki raunda başlamak için yeniden doğ veya menüye dön.",
  "pause.title": "Oyun menüsü",
  "pause.resume": "Devam et",
  "pause.menu": "Ana menüye dön",
  "upgrade.title": "Bir yükseltme seç",
  "upgrade.generic.title": "Yükseltme",
  "upgrade.generic.description": "Buildini geliştir.",
  "upgrade.newWeaponPrefix": "Yeni silah:",
  "upgrade.stat.maxHp.title": "Maks. can",
  "upgrade.stat.maxHp.description": "Maksimum canÄ± artÄ±rÄ±r.",
  "upgrade.stat.speed.title": "Hareket hÄ±zÄ±",
  "upgrade.stat.speed.description": "Hareket hÄ±zÄ±nÄ± artÄ±rÄ±r.",
  "upgrade.stat.generic.title": "Stat yükseltmesi",
  "upgrade.stat.generic.description": "Statlarını geliştir.",
  "upgrade.weapon.projectileShot.title": "Mermi atışı",
  "upgrade.weapon.projectileShot.description": "Buildine mermi atışları ekler.",
  "upgrade.weapon.orbitingBalls.title": "Yörünge topları",
  "upgrade.weapon.orbitingBalls.description": "Buildine yörünge topları ekler.",
  "upgrade.weapon.damageZone.title": "Hasar alanÄ±",
  "upgrade.weapon.damageZone.description": "Karakterin etrafÄ±na hasar alanÄ± ekler.",
  "upgrade.weapon.generic.title": "Silah",
  "upgrade.weapon.generic.description": "Bu silahÄ± buildine ekle.",
  "upgrade.weaponUpgrade.frequency.title": "Frekans",
  "upgrade.weaponUpgrade.frequency.description": "Daha sÄ±k saldÄ±r.",
  "upgrade.weaponUpgrade.range.title": "Menzil",
  "upgrade.weaponUpgrade.range.description": "Silah menzilini artÄ±rÄ±r.",
  "upgrade.weaponUpgrade.projectileCount.title": "Mermi sayÄ±sÄ±",
  "upgrade.weaponUpgrade.projectileCount.description": "Daha fazla mermi oluşturur.",
  "upgrade.weaponUpgrade.projectileSpeed.title": "Mermi hÄ±zÄ±",
  "upgrade.weaponUpgrade.projectileSpeed.description": "Mermileri daha hÄ±zlÄ± yapar.",
  "upgrade.weaponUpgrade.orbitalSpeed.title": "Yörünge hızı",
  "upgrade.weaponUpgrade.orbitalSpeed.description": "Yörünge toplarını daha hızlı döndürür.",
  "upgrade.weaponUpgrade.damage.title": "Hasar",
  "upgrade.weaponUpgrade.damage.description": "Daha fazla hasar ver.",
  "upgrade.weaponUpgrade.generic.title": "Silah yükseltmesi",
  "upgrade.weaponUpgrade.generic.description": "Bu silahı geliştir.",
  "defeat.title": "Yenilgi",
  "defeat.subtitle": "Yeniden doğ veya menüye dön",
  "defeat.respawn": "Yeniden doğ",
  "defeat.menu": "Ana menü",
  "error.generic": "Bir şeyler ters gitti.",
} as const;
